/**
 * 解析图片URL
 * @param {string|object} imageUrl - 原始图片URL数据
 * @returns {string} 处理后的图片URL
 */
export function parseImageUrl(imageUrl) {
  if (!imageUrl) return '';
  
  try {
    // 如果输入已经是对象，直接使用；否则尝试解析JSON字符串
    const parsed = typeof imageUrl === 'string' ? JSON.parse(imageUrl) : imageUrl;
    
    // 处理数组情况
    if (Array.isArray(parsed) && parsed.length > 0) {
      const firstImage = parsed[0];
      
      // 处理完整URL的情况（华为云OBS链接）
      if (firstImage.FilePath && firstImage.FilePath.startsWith('http')) {
        return firstImage.FilePath;
      }
      
      // 处理需要组合ServerUrl的情况
      if (firstImage.ServerUrl && firstImage.FilePath) {
        // 确保路径正确拼接，避免双斜杠
        const serverUrl = firstImage.ServerUrl.endsWith('/') ? firstImage.ServerUrl.slice(0, -1) : firstImage.ServerUrl;
        const filePath = firstImage.FilePath.startsWith('/') ? firstImage.FilePath : `/${firstImage.FilePath}`;
        return `${serverUrl}${filePath}`;
      }
      
      // 如果只有FilePath
      if (firstImage.FilePath) {
        return firstImage.FilePath;
      }
    }
    
    // 如果是单个对象
    if (parsed && typeof parsed === 'object') {
      // 使用相同的逻辑处理单个对象
      if (parsed.FilePath && parsed.FilePath.startsWith('http')) {
        return parsed.FilePath;
      }
      
      if (parsed.ServerUrl && parsed.FilePath) {
        const serverUrl = parsed.ServerUrl.endsWith('/') ? parsed.ServerUrl.slice(0, -1) : parsed.ServerUrl;
        const filePath = parsed.FilePath.startsWith('/') ? parsed.FilePath : `/${parsed.FilePath}`;
        return `${serverUrl}${filePath}`;
      }
      
      if (parsed.FilePath) {
        return parsed.FilePath;
      }
    }
    
    // 如果解析结果是字符串，直接返回
    if (typeof parsed === 'string') {
      return parsed;
    }
    
  } catch (e) {
    // 如果解析失败，检查是否本身就是URL字符串
    if (typeof imageUrl === 'string') {
      return imageUrl;
    }
  }
  
  return '';
} 